/* eslint-disable @next/next/link-passhref */
/* eslint-disable jsx-a11y/alt-text */
import Image from "next/image";
import Link from "next/link";
// import DropdownButton from "react-bootstrap/DropdownButton";
import { useDispatch, useSelector } from "react-redux";
import { Dropdown, Nav, Overlay, OverlayTrigger, Popover, Tooltip } from "react-bootstrap";
import { useRouter } from "next/router";
import React, { useState, useRef, useEffect } from 'react';
import { handleFavouriteLish } from "../../store/actions/favouriteAction";

const Dashboardheader = () => {
  const Router = useRouter();
  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const ref = useRef(null);

  const auth = useSelector((state) => state.auth);
  const { isLoggedIn } = auth;
  const routerNav = (e) => {
    Router.push(e);
    return;
  }
  const handleClick = (event) => {
    setShow(!show);
    setTarget(event.target);
  };
  // const favoriteInfo = [];
  const dispatch = useDispatch();
  // if (isLoggedIn) {
  useEffect(() => {
    dispatch(handleFavouriteLish());
  }, [dispatch]);
  // const size = FunWindowSize();
  const favoriteInfo = useSelector((state) => state?.favouriteInfo.favouriteInfo.data);

  // }

  // console.log(favoriteInfo, 'favoriteInfofavoriteInfofavoriteInfo')
  return (
    <div>
      <nav className="navbar navbar-light bg-white shadow-sm dashnavbar fixed-top">
        <div className="container-fluid">
          <Link href="/">
            <a className="navbar-brand pt-0 pb-0">
              <Image src="/assets/images/logo.png" width={231} height={52} />
            </a>
          </Link>
          <div className="dashnavbar-right">
            <OverlayTrigger
              key={'bottom'}
              placement={'bottom'}
              overlay={
                <Popover id="popover-basic">
                  <Popover.Header as="h3">Popover right</Popover.Header>
                  <Popover.Body>
                    And heres some <strong>amazing</strong> content. Its very engaging.
                    right?
                  </Popover.Body>
                </Popover>
              }
            >
              <span className="btn btn-message-circle" onClick={(e) => routerNav('/favorite')}>
              </span >
            </OverlayTrigger>

              <div>
           {isLoggedIn && <div ref={ref}>
              {/* <Button onClick={handleClick}>Holy guacamole!</Button> */}
              <span className="btn btn-feather-star" onClick={handleClick}></span>
              <Overlay
                show={show}
                target={target}
                placement="bottom"
                container={ref}
                containerPadding={20}
              >
                <Popover id="popover-contained">
                  <Popover.Header as="h3">Favoris</Popover.Header>
                  <> {favoriteInfo && favoriteInfo.length > 0 ? favoriteInfo.map((item, index) => (
                    <span key={index}>
                      <Popover.Body>
                        <strong>{item.name}</strong> {item.sub_title}.
                      </Popover.Body>
                    </span>
                  ))
                    : null}</>
                </Popover>
              </Overlay>
            </div>
            }
</div>
            {/* <OverlayTrigger
              key={'bottom1'}
              placement={'bottom'}
              overlay={
                 <Popover id="popover-basic">
                 <Popover.Header as="h3">Popover right</Popover.Header>
                 <Popover.Body>
                   And heres some <strong>amazing</strong> content. Its very engaging.
                   right?
                 </Popover.Body>
               </Popover>
              }
            >
              <span className="btn btn-feather-star"  onClick={(e) => routerNav('/')}></span>
            </OverlayTrigger> */
            }
{isLoggedIn && (<div className="dropdown dashboard-profile-w" >
            <button className="dropbtn profile-btn" style={{borderRadius:"999px"}}><span className="p-icon">
              <img src="/assets/images/USer.png" alt="" />
</span>Profil</button>
            <div className="dropdown-content">
              <Nav.Link href="/profile">PROFIL</Nav.Link>
              <Nav.Link href='/changepassword'>CHANGE PASSWORD</Nav.Link>
            </div>
          </div> )}
            {!isLoggedIn && (<Dropdown>
              <Dropdown.Toggle variant="none" className="user-dropdown-right" onClick={(e) => routerNav('/login')}>
                <span className="userImage">
                  <Image src="/assets/images/USer.png" width={40} height={40} />
                </span>{" "}
                Se connecter
              </Dropdown.Toggle>
              {/* <Dropdown.Menu className="dropdown-login-form">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Email ou téléphone"
                />
                <input
                  type="password"
                  className="form-control mt-3"
                  placeholder="Password"
                />
              </Dropdown.Menu> */}
            </Dropdown>)}

            {isLoggedIn &&
              (<Nav style={{ marginLeft: 15 }}>
                <Link suppressHydrationWarning href="/logout">
                  <a style={{ padding: '14px 24px', minWidth: '125px', textAlign: 'center', background: '#FF9B07', color: '#fff', textDecoration: 'none', borderRadius: 30 }}> Déconnexion</a>
                </Link>
              </Nav>)
            }
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Dashboardheader;
